module.exports = __webpack_public_path__ + "img/play.467a2a14.png";